import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { locationFormDefault } from "@factory/form/form.default";
import { LocationFormRule, LocationFormSchema } from "@factory/form/form.rule";
import { useQyCreateLocation } from "@factory/query/location.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewLocation() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateLocation } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Location is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addLocation, isLoading: isCreating } =
    useQyCreateLocation(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<LocationFormSchema>({
    defaultValues: locationFormDefault,
    resolver: zodResolver(LocationFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: LocationFormSchema) => {
    const formData = mapCreateLocation(form);
    addLocation(formData);
  };
  const handleValidateError = (err: FieldErrors<LocationFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
